import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import {
  PagePaginationResponseDtoSchema,
  responseContract,
  type PagePaginationRequestDto,
} from '../../lib';
import {
  ResidentsDtoSchema,
  type PayerType,
  type PayPositionCategory,
} from '../contracts';

const GetResidentsResponseDtoSchema =
  PagePaginationResponseDtoSchema(ResidentsDtoSchema);

export type GetResidentsRequestDto = PagePaginationRequestDto<
  {
    search: string | null;
    facilitiesIds?: number[];
    careLevelsIds?: number[];
    payerTypes?: PayerType | null;
    flagged: boolean | null;
    payPositions?: PayPositionCategory[];
  },
  | 'name'
  | 'facilityName'
  | 'rate'
  | 'totalRevenue'
  | 'payType'
  | 'levelOfCare'
  | 'payPosition'
  | 'flagged'
  | 'activeAlerts'
  | 'createdAlerts'
>;
export type GetResidentsResponseDto = z.infer<
  typeof GetResidentsResponseDtoSchema
>;

export const getResidents = (
  params: GetResidentsRequestDto,
  config?: AxiosRequestConfig<GetResidentsRequestDto>
) => {
  const transformedParams: GetResidentsRequestDto = {
    ...params,
    search: params.search?.trim() ? params.search.trim() : null,
  };

  return api
    .get('/residents', {
      params: transformedParams,
      ...config,
    })
    .then(responseContract(GetResidentsResponseDtoSchema));
};
